module.exports = __webpack_public_path__ + "img/popup2.97691b18.png";